<template>
    <div class="row">
        <slot></slot>
    </div>
</template>
<style scoped lang="scss">
.row {
    display: flex;
    gap: 24px;
}
</style>
